import { chunk } from "lodash";
import { LocalData } from "to-be-removed/LocalData/General/LocalData";

export const getPropertyRolesFlatList = (): string[] => {
  const flatRolesList: string[] = [];

  for (const property of LocalData.currentUser.properties) {
    const member = property.members.getData(LocalData.currentUser.id);
    for (const role of member?.roles ?? []) {
      flatRolesList.push(property.id + "/" + role.id);
    }
  }

  return flatRolesList;
};

export const getPropertyRolesLists = (): string[][] => {
  const flatRolesList = getPropertyRolesFlatList();
  const propertyRolesList: string[][] = chunk(flatRolesList, 30);
  return propertyRolesList;
};

export const getOperationManagerPropertiesFlatList = (): string[] => {
  const flatRolesList: string[] = [];

  for (const property of LocalData.currentUser.properties) {
    const member = property.members.getData(LocalData.currentUser.id);
    if (member?.isOperationManager) {
      flatRolesList.push(property.id);
    }
  }

  return flatRolesList;
};

export const getOperationManagerPropertiesLists = (): string[][] => {
  const flatRolesList = getOperationManagerPropertiesFlatList();
  const propertyRolesList: string[][] = chunk(flatRolesList, 30);
  return propertyRolesList;
};

